import { AudienceModel } from '../../../models/audience.model';
import { CompoundTriggerModel } from '../../../models/compound-trigger.model';
import { DatasetListModel } from '../../../models/dataset.model';
import { FormulaDetailModel } from '../../../models/formula.model';
import { TagModel } from '../../../models/tag.model';

import { SearchableSelectType } from '../../inputs/searchableSelect';

export type FilterOption = {
    label: string;
    value: string;
    info: number;
};

export function getAudienceFilterOptions(
    data: FormulaDetailModel[],
    key: keyof FormulaDetailModel,
    audiences?: AudienceModel[],
    extraKey?: string,
): FilterOption[] {
    const countMap = new Map<string, { name: string; count: number }>();
    const validAudienceIds = new Set<string>();
    data?.forEach((item) => {
        if (audiences && extraKey) {
            if (audiences && (item[key] as any[])?.length) {
                const id = (item[key] as any[])[0][extraKey];
                validAudienceIds.add(id);
                const exData = audiences.find((item) => item.id === id);
                if (exData) {
                    countMap.set(exData.id, {
                        name: exData.name,
                        count: (countMap.get(exData.id)?.count ?? 0) + 1,
                    });
                }
            }
        }
    });
    return Array.from(countMap).map(([id, { name, count }]) => ({
        label: name,
        value: id,
        info: count,
    }));
}
export function getTriggerFilterOptions(
    data: FormulaDetailModel[],
    key: keyof FormulaDetailModel,
): FilterOption[] {
    const countMap = new Map<string, { name: string; count: number }>();
    data?.forEach((item) => {
        const value = item[key] as CompoundTriggerModel;
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            const obj: any = value;
            if (obj.id && obj.name) {
                countMap.set(obj.id, {
                    name: obj.name,
                    count: (countMap.get(obj.id)?.count ?? 0) + 1,
                });
            }
        }
    });
    return Array.from(countMap).map(([id, { name, count }]) => ({
        label: name,
        value: id,
        info: count,
    }));
}
export function getTagFilterOptions(
    data: FormulaDetailModel[],
    key: keyof FormulaDetailModel,
): FilterOption[] {
    const countMap = new Map<string, { name: string; count: number }>();
    data?.forEach((item) => {
        const value = item[key] as TagModel[];
        if (Array.isArray(value)) {
            value.forEach((obj: any) => {
                if (obj && typeof obj === 'object' && obj.id && obj.name) {
                    const id = obj.name;
                    countMap.set(id, {
                        name: obj.name,
                        count: (countMap.get(id)?.count ?? 0) + 1,
                    });
                }
            });
        }
    });
    return Array.from(countMap).map(([id, { name, count }]) => ({
        label: name,
        value: id,
        info: count,
    }));
}

export function getDatasetFilterOptions(
    data: FormulaDetailModel[],
    datasets?: DatasetListModel[],
): FilterOption[] {
    const countMap = new Map<string, { name: string; count: number }>();
    data?.forEach((item) => {
        if (item.dataset_id) {
            const id = String(item.dataset_id);
            const dataset = datasets?.find((d) => d.id === item.dataset_id);
            if (dataset) {
                countMap.set(id, {
                    name: dataset.name,
                    count: (countMap.get(id)?.count ?? 0) + 1,
                });
            }
        }
    });
    return Array.from(countMap).map(([id, { name, count }]) => ({
        label: name,
        value: id,
        info: count,
    }));
}

export function getScheduledFilterOptions(
    data: FormulaDetailModel[],
    key: keyof FormulaDetailModel,
    otherData: SearchableSelectType[],
): FilterOption[] {
    const countMap = new Map<string, { name: string; count: number }>();
    data?.forEach((item) => {
        const value = item[key] as TagModel[];
        if (otherData) {
            const exData = Object.values(otherData).find(
                (item) => item.value === String(value),
            );
            if (exData) {
                countMap.set(exData.value as string, {
                    name: exData.label,
                    count:
                        (countMap.get(exData.value as string)?.count ?? 0) + 1,
                });
            }
        }
    });
    return Array.from(countMap).map(([id, { name, count }]) => ({
        label: name,
        value: id,
        info: count,
    }));
}
